// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1__d439eb8f7603894da8df","cls2":"Comment-cls2___3c4da633221bd439311 Comment-cls1__d439eb8f7603894da8df"};